import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  IconName,
  Tooltip,
} from '@usealloy/component-library';

import WatchlistReview from '~/entities/evaluations/watchlist-review/WatchlistReview';
import JourneyApplicationContext from '~/application-review/context';
import { UserContext } from '~/dashboard/context';
import { SideviewPanel } from '~/entities/evaluations/EvaluationTabs/SideviewPanel';
import { WatchlistAgentPanel } from '~/entities/evaluations/EvaluationTabs/WatchlistAgentPanel/WatchlistAgentPanel';

interface WatchlistMatchesProps {
  evaluation: {
    entity_token: string;
    evaluation_token: string;
  };
}

const WatchlistMatches = ({ evaluation }: WatchlistMatchesProps) => {
  const { currentAgentIsAssigned } = useContext(JourneyApplicationContext);
  const { featureFlags } = useContext(UserContext);
  const [isAgentPanelOpen, setIsAgentPanelOpen] = useState(false);

  return (
    <>
      {featureFlags?.llmWatchlistAgent && (
        <Box
          direction="row"
          justifyContent="flex-end"
          style={{ width: '100%', marginBottom: '-45px' }}
        >
          <Tooltip content="Open AI Watchlist Screening">
            <Button
              icon={IconName.WandMagicSparkles}
              onClick={() => setIsAgentPanelOpen(true)}
              style={{ backgroundColor: 'var(--cl-purple-100)' }}
              data-dd-action-name="alloydd-ai-watchlist-triggered"
            />
          </Tooltip>
        </Box>
      )}

      <WatchlistReview
        canAgentResolve={currentAgentIsAssigned}
        entityToken={evaluation.entity_token}
        evaluationToken={evaluation.evaluation_token}
        showLatestDecisions
      />

      {isAgentPanelOpen && (
        <SideviewPanel
          onClose={() => setIsAgentPanelOpen(false)}
          panelTitle="Watchlist Screening"
          collapsedTabTooltip="Open Watchlist Screening"
        >
          <WatchlistAgentPanel
            entityToken={evaluation.entity_token}
            evaluationToken={evaluation.evaluation_token}
            onClose={() => setIsAgentPanelOpen(false)}
          />
        </SideviewPanel>
      )}
    </>
  );
};

export default WatchlistMatches;
